export default __webpack_public_path__ + "static/media/cynosuraloil.7c1a5752.jpg";